import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { HomeEffects } from './home.effects';
import { reducer } from './home.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('home', reducer),
    EffectsModule.forFeature([HomeEffects]),
  ],
  providers: [HomeEffects],
})
export class HomeStoreModule {}
